import React from 'react';

import Link from '../Link/Link';

const footer = () => {
  const mapsUrl = 'https://share.google/wj8How7D9GaZvJJha';
  const instagramUrl = 'https://www.instagram.com/goldnar.guzellik.salonu/';

  return (
    <footer className=''>
      <div className='container text-light pt-5'>
        <div className='row'>
          <div className='col-sm-6 col-md-6 col-lg-4 mb-5'>
            <div className='footer-title'>
              <h6>Hakkında</h6>
            </div>
            <div className='footer-content'>
              <p>
                <small className='text-muted'>
                Erzincan Gold Nar Güzellik olarak cilt bakımı, lazer epilasyon, kalıcı makyaj ve bölgesel bakım uygulamalarında modern, hijyenik ve özenli hizmet sunuyoruz.
                </small>
              </p>
              <a
                  href={mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary mr-2"
                >
                  Konumu Gör
                </a>
            </div>
          </div>
          <div className='col-sm-6 col-md-6 col-lg-2 mb-5'>
            <div className='footer-title'>
              <h6>Bağlantılar</h6>
            </div>
            <div className='footer-content'>
              <ul className='list-group quick-links'>
                <li>
                  <Link target='home' offset={-120}>
                    Anasayfa
                  </Link>
                </li>
                <li>
                  <Link target='about'>Hakkında</Link>
                </li>
                <li>
                  <Link target='services'>Hizmetler</Link>
                </li>
                <li>
                  <Link target='blog'>Blog</Link>
                </li>
                <li>
                  <Link target='contact'>İletişim</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className='col-sm-6 col-md-6 col-lg-3 mb-5'>
            <div className='footer-title'>
              <h6>Çalışma Saatleri</h6>
            </div>
            <div className='footer-content'>
            <table className="table table-striped" >
                    
                    <tbody>
                        <tr style={{height:"2px", color:"gray", fontSize:"small"}}>
                            <td>Haftaiçi</td>
                            <td>09:00 - 19:00</td>
                        </tr>
                        <tr style={{height:"2px", color:"gray",fontSize:"small"}}>
                            <td>Cumartesi</td>
                            <td>09:00 - 19:00</td>
                        </tr>
                        <tr style={{height:"2px", color:"gray",fontSize:"small"}}>
                            <td>Pazar</td>
                            <td>09:00 - 19:00</td>
                        </tr>
                      
                    </tbody>
                    
                    </table>
            </div>
          </div>
          <div className='col-sm-6 col-md-6 col-lg-3 mb-5'>
            <div className='footer-title'>
              <h6>İletişim Bilgileri</h6>
            </div>
            <div className='footer-content'>
              <p className='text-muted'>
                <small> <span style={{color:"white"}}>Adres : </span> Atatürk Mah. 357. Sk. No:2 İç Kapı No:301, Merkez / Erzincan 24100, Türkiye</small>
              </p>
              <p className='text-muted'>
                <small><span style={{color:"white"}}>Telefon : </span><a href="tel:+905433012423">+90 543 301 24 23</a></small>
              </p>
              <p className='text-muted'>
                <small><span style={{color:"white"}}>Instagram : </span><a href={instagramUrl} target="_blank" rel="noopener noreferrer">@goldnar.guzellik.salonu</a></small>
              </p>
              <div className='social-media mt-4'>
                <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className='text-light'>
                  <i className='fas fa-location-arrow mr-2' />
                  Haritada Aç
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bottom-footer pt-3 pb-3 text-center'>
        <small>© All Right Reserved. Design By Berati Şahin</small>
      </div>
    </footer>
  );
};

export default footer;
